﻿import React, { Fragment } from 'react';

import { Route, Routes, Navigate, useParams } from 'react-router-dom'

import { UserAccess } from 'components/user-access';

import { VerticalLinkGroup, Breadcrumbs } from 'components/navigation';
import { PageRestricted } from 'pages/errors/page-restricted';
import { PolicyChangelog } from './edit/changelog';
import { PolicyEdit } from 'pages/policy/edit';

export function Policy(props) {
    const { id } = useParams();
    let routes = [
        { location: `/policy-management/policies/${id}/policy-details`, title: "Policy Details" },
        { location: `/policy-management/policies/${id}/policy-settings`, title: "Settings" },
        { location: `/policy-management/policies/${id}/policy-additional-settings`, title: "Additional Settings" },
        { location: `/policy-management/policies/${id}/document-details`, title: "Document Details" },
        { location: `/policy-management/policies/${id}/changes`, title: "History" }
    ];

    return (
        <UserAccess perform={["Documents:Manage"]}
            yes={() => (
                <Fragment>
                    <div className="row">

                        <Breadcrumbs items={props.breadcrumbs} />

                        <h1>Policy Details</h1>
                        <div className="intro-text">
                            <p>Here you can configure your policy details.</p>
                        </div>
                    </div>

                    <div className="layout-cols">
                        <div className="col side-col">
                            <div className="row">
                                <VerticalLinkGroup links={routes}></VerticalLinkGroup>
                            </div>
                        </div>
                        <div className="col content-col">
                            <Routes>
                                <Route path="policy-details" element={<PolicyEdit policyId={id} show='Policy Details' />} />
                                <Route path="policy-settings" element={<PolicyEdit policyId={id} show='Settings' />} />
                                <Route path="policy-additional-settings" element={<PolicyEdit policyId={id} show='Additional Settings' />} />
                                <Route path="document-details" element={<PolicyEdit policyId={id} show='Documents' />} />
                                <Route path="changes" element={<PolicyChangelog policyId={id} />} />
                                <Route path="" element={<Navigate to={`/policy-management/policies/${id}/policy-details`} replace />} />
                            </Routes>
                        </div>


                    </div>
                </Fragment>
            )}
            no={() => (
                <PageRestricted />
            )}
        />

    );

}